export default __webpack_public_path__ + "static/coinbase-a7f9e4f77508955a848ff4cedde9bc58.png";